export const GET_BENEFIT_DOCUMENT_DATA_QUERY_KEY = [
  'getBenefitDocumentData',
] as const;

export const ALLOWED_BENEFIT_DOCUMENT_TYPE_EXTENSIONS = [
  '.doc',
  '.docx',
  '.pdf',
  '.txt',
] as const;
